<template>
    <div class="member-center parent-frame"  :class="{'fixed': listIsFixed}">
        <transition name="fade"> 
            <alart-msg :display="alarm.msg" :styleType="alarm.type" @alartStatus="closeAlart">
                <span class="title" slot="title">{{alarm.msg}}</span>
            </alart-msg>
        </transition>  
        <div class="tool-bar-mask"></div>
        <Breadcrumb />
        <member-amount></member-amount>
        <span class="logout" @click="logout(), $analytics.logEvent('登出', { screen_name: '登出'})">登出</span>
        <tabs :key="componentKey">
            <tab name="認證房東" :selected="selected.verified" >
                <member-verified></member-verified>
            </tab>
            <tab name="個資編輯" :selected="selected.person">
                <member-person></member-person>
            </tab>
            <tab name="飛豬錢包" :selected="selected.wallet">
                <member-wallet></member-wallet>
            </tab>
            <tab name="委託付款紀錄" :selected="selected.taskPaymentRecord">
                <task-payment-record></task-payment-record>
            </tab>
            <tab name="共同設定" :selected="selected.config">
                <com-setting></com-setting>
            </tab>
            <!-- <tab name="操作日誌" :selected="selected.action">
            </tab>
            <tab name="通知" :selected="selected.alarm">
                <member-alarm></member-alarm>
            </tab> -->
        </tabs>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import MemberAmount from '@/components/landlord/houseStatus/memberCenter/MemberAmount.vue';
import MemberVerified from '@/components/landlord/houseStatus/memberCenter/MemberVerified.vue';
import MemberPerson from '@/components/landlord/houseStatus/memberCenter/MemberPerson.vue';
import MemberWallet from '@/components/landlord/houseStatus/memberCenter/memberWallet/MemberWallet.vue';
import taskPaymentRecord from '@/components/landlord/houseStatus/memberCenter/taskPaymentRecord.vue';
import MemberAlarm from '@/components/landlord/houseStatus/memberCenter/MemberAlarm.vue';
import ComSetting from '@/components/landlord/houseStatus/memberCenter/ComSetting.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            listIsFixed: false,
            selected: {
                verified: false,
                person: false,
                wallet: false,
                taskPaymentRecord: false,
                config: false,
                action: false,
                alarm: false,
                
            },
            componentKey: 0,
        }
    },
    created (){
        this.forceUpdate()
    },
    mounted () {
            this.$analytics.logEvent('會員中心', { screen_name: '會員中心'})
            window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route(to, from) {
            this.forceUpdate()
        }
    },
    methods: {
        closeAlart: function () {
            this.$store.commit('memberCenter/set_alarm_msg', {type: null, msg: null})
        },
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                // console.log(scrollTop)
                if( scrollTop >= 230){
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('member-center')[0].style.zIndex = '8'
                }else{
                    document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('member-center')[0].style.zIndex = '6'
                    this.listIsFixed = false
                }

                if( scrollTop >= 230){
                    this.listIsFixed = true
                }
            }
        },
        logout: function () {
            this.$store.dispatch('logout')
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)

            if( hashTag == '#認證房東' ){
                console.log('認證房東')
                this.$analytics.logEvent('認證房東', { screen_name: '認證房東'})
                this.selected.verified = true
            }if( hashTag == '#個資編輯' ){
                this.$analytics.logEvent('個資編輯', { screen_name: '個資編輯'})
                this.selected.person = true
            }else if( hashTag == '#飛豬錢包' ){
                this.$analytics.logEvent('飛豬錢包', { screen_name: '飛豬錢包'})
                this.selected.wallet = true
            }else if( hashTag == '#委託付款紀錄' ){
                this.$analytics.logEvent('委託付款紀錄', { screen_name: '委託付款紀錄'})
                this.selected.taskPaymentRecord = true
            }else if( hashTag == '#共同設定' ){
                this.$analytics.logEvent('共同設定', { screen_name: '共同設定'})
                this.selected.config = true
            }else if( hashTag == '#操作日誌' ){
                this.$analytics.logEvent('操作日誌', { screen_name: '操作日誌'})
                this.selected.action = true
            }else if( hashTag == '#通知' ){
                this.$analytics.logEvent('通知', { screen_name: '通知'})
                this.selected.alarm = true
            }else{
                console.log('認證房東')
                this.$analytics.logEvent('認證房東', { screen_name: '認證房東'})
                this.selected.verified = true
            }
        },
        setSelectTabAllFalse: function () {
            this.selected.verified = false
            this.selected.person = false
            this.selected.wallet = false
            this.selected.taskPaymentRecord = false
            this.selected.config = false
            this.selected.action = false
            this.selected.alarm = false
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        }

    },
    computed: {
        ...mapGetters({
            alarm: 'GET_MEMBER_CENTER_ALARM',
            isModalMode: 'GET_MODAL_MODE'
        })
    },
    components: {
        Breadcrumb,
        Tabs,
        Tab,
        MemberAmount,
        MemberVerified,
        MemberPerson,
        MemberWallet,
        ComSetting,
        MemberAlarm,
        AlartMsg,
        taskPaymentRecord
    }
}
</script>
<style lang="scss" scoped>
    .member-center{
        position: relative;
        margin-top: 82px;
        z-index: 6;
        .logout{
            position: absolute;
            right: 27px;
            color: #ff9275;
            z-index: 5;
            cursor: pointer;
        }
    }
    .member-center.fixed{
        .tool-bar-mask{
            position: fixed;
            width: 100%;
            background: #fff;
            height: 80px;
            top: 0px;
            z-index: 7;
            margin-left: -39px;
            border-bottom: 1px solid #f0f0f0;
        }
        .tabs{
            position: fixed;
            z-index: 9;
            top: 29px;
        }
        // button.wallet{
        //     position: fixed;
        //     top: 18px;
        //     z-index: 9;
        //     margin-left: 597px;
        //     right: unset;
        //     margin-left: 956px;
        // }
        .logout{
            position: fixed;
            top: 31px;
            z-index: 9;
            right: unset;
            margin-left: 1119px;
        }
    }
    @media screen and (max-width: 1280px) {
        .member-center.fixed{
            .logout{
                margin-left: 1082px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/HouseStatusSubPages/MemberCenter.vue